import Swiper from 'swiper'
import { Autoplay } from 'swiper/modules'

type MobileMenuTriggerState = 'open' | 'close' | 'back'
export default function () {
	function initHeaderScripts() {
		initStickyHeader()
		initFiboSearch()
		initMobileSearch()
		initMobileMenu()
		initTopbarSwiper()
		initDesktopDropdownMenu()
	}

	function initStickyHeader() {
		let lastScrollTop = 0
		const header = document.getElementById('header')
		const stickyHeader = document.getElementById('sticky-header')

		if (!stickyHeader || !header) return

		let isTicking = false
		window.addEventListener('scroll', () => {
			if (!isTicking) {
				window.requestAnimationFrame(() => {
					handleScroll()
					isTicking = false
				})
				isTicking = true
			}
		})

		function handleScroll() {
			const scrollTop = window.scrollY || document.documentElement.scrollTop

			if (document.body.classList.contains('has-mobile-menu')) {
				return
			}
			if (!stickyHeader) return
			if (!header) return

			const isScrolledPastHeader = scrollTop > header.getBoundingClientRect().height
			if (isScrolledPastHeader) {
				if (scrollTop > lastScrollTop) {
					document.body.classList.remove('has-sticky-header')
					stickyHeader.classList.remove('active')
				} else {
					document.body.classList.add('has-sticky-header')
					stickyHeader.classList.add('active')
				}
			} else {
				document.body.classList.remove('has-sticky-header')
				stickyHeader.classList.remove('active')
			}
			lastScrollTop = scrollTop <= 0 ? 0 : scrollTop
		}
	}

	function initFiboSearch() {
		document.querySelectorAll('.js-wrapped-fibo-trigger').forEach((trigger) => {
			const target = trigger.querySelector('.js-wrapped-fibo-trigger-target')
			const source = trigger.querySelector('.js-wrapped-fibo-trigger-source')
			if (target && source) {
				if (trigger.classList.contains('js-wrapped-fibo-trigger-icon')) {
					const handler = target.querySelector('.js-dgwt-wcas-search-icon-handler')
					if (handler) {
						handler.innerHTML = source.innerHTML
					}
				}
				source.remove()
			}
		})

		const searchIconSvg = `
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_2200_1740)">
				<path d="M22.5286 24L13.7609 15.2319C13.0629 15.8082 12.2602 16.2592 11.3528 16.5849C10.4454 16.9106 9.50673 17.0735 8.53675 17.0735C6.15079 17.0735 4.13151 16.2474 2.47891 14.5953C0.826303 12.9432 0 10.9243 0 8.53885C0 6.15359 0.82607 4.13407 2.47821 2.4803C4.13035 0.826768 6.14917 0 8.53466 0C10.9199 0 12.9394 0.826302 14.5932 2.47891C16.2467 4.13151 17.0735 6.15079 17.0735 8.53675C17.0735 9.53371 16.9062 10.4859 16.5717 11.3933C16.2369 12.3007 15.7903 13.0899 15.2319 13.7609L23.9997 22.5286L22.5286 24ZM8.53675 14.9799C10.3355 14.9799 11.8589 14.3557 13.1072 13.1072C14.3557 11.8589 14.9799 10.3355 14.9799 8.53675C14.9799 6.73804 14.3557 5.21456 13.1072 3.96632C11.8589 2.71785 10.3355 2.09362 8.53675 2.09362C6.73804 2.09362 5.21456 2.71785 3.96632 3.96632C2.71785 5.21456 2.09362 6.73804 2.09362 8.53675C2.09362 10.3355 2.71785 11.8589 3.96632 13.1072C5.21456 14.3557 6.73804 14.9799 8.53675 14.9799Z" fill="var(--color)"/>
			</g>
			<defs><clipPath id="clip0_2200_1740"><rect width="24" height="24" fill="white"/></clipPath></defs>
		</svg>
	`
		document
			.querySelectorAll('.dgwt-wcas-search-submit')
			.forEach((el) => (el.innerHTML = searchIconSvg))

		const closeFiboButtonHtml = `
		<button class="dgwt-wcas-search-close-copy" type="button">
			<svg width="18" height="20" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M4.95022 16.5L4 15.5498L9.04978 10.5L4 5.45022L4.95022 4.5L10 9.54978L15.0498 4.5L16 5.45022L10.9502 10.5L16 15.5498L15.0498 16.5L10 11.4502L4.95022 16.5Z" fill="#A8CA9E"/>
			</svg>
		</button>
	`
		document
			.querySelectorAll(
				'.header-search-form .dgwt-wcas-sf-wrapp, .sticky-header .dgwt-wcas-sf-wrapp',
			)
			.forEach((el) => {
				el.insertAdjacentHTML('beforeend', closeFiboButtonHtml)
			})

		document.querySelectorAll('.dgwt-wcas-search-close-copy').forEach((button) => {
			button.addEventListener('click', () => {
				const overlay = document.querySelector('.dgwt-wcas-darkened-overlay') as HTMLElement | null
				if (overlay) {
					overlay.click()
				}
			})
		})
	}

	function initMobileSearch() {
		const mobileSearchEl = document.getElementById('mobile-search')
		const mobileSearchToggleEls = document.querySelectorAll('.js-mobile-search-toggle')

		if (!mobileSearchEl || !mobileSearchToggleEls.length) return

		mobileSearchToggleEls.forEach((toggle) => {
			toggle.addEventListener('click', () => {
				mobileSearchEl.classList.toggle('active')
				document.body.classList.toggle('modal-active')
			})
		})
	}

	function initMobileMenu() {
		const mobileMenuEl = document.getElementById('mobile-menu')
		if (!mobileMenuEl) return

		document.body.addEventListener('click', (e) => {
			const target = e.target as HTMLElement | null
			if (!target) return

			if (target.closest('.js-mobile-menu-trigger-open')) {
				handleOpen()
			} else if (target.closest('.js-mobile-menu-trigger-close')) {
				handleClose()
			} else if (target.closest('.js-mobile-menu-trigger-back')) {
				handleBack()
			} else if (target.closest('.js-mobile-menu-go')) {
				handleGo(target.closest('.js-mobile-menu-go'))
			}
		})

		function toggleMobileMenu() {
			const headerSelector = document.body.classList.contains('has-sticky-header')
				? '.sticky-header'
				: '.header-nav-wrapper'
			const headerNavWrapper = document.querySelector(headerSelector)
			if (!headerNavWrapper) return
			if (!mobileMenuEl) return

			const rect = headerNavWrapper.getBoundingClientRect()
			mobileMenuEl.style.setProperty('--top', `${rect.bottom}px`)
			mobileMenuEl.style.setProperty('--height', `${window.innerHeight - rect.bottom}px`)

			mobileMenuEl.classList.toggle('active')
			document.body.classList.toggle('modal-active')
			document.body.classList.toggle('has-mobile-menu')
		}

		function changeMobileMenuTriggerState(state: MobileMenuTriggerState) {
			document.querySelectorAll('.mobile-menu-trigger').forEach((trigger) => {
				trigger
					.querySelectorAll('[class*="js-mobile-menu-trigger-"]')
					.forEach((el) => el.classList.remove('active'))
				const activeStateEl = trigger.querySelector(`.js-mobile-menu-trigger-${state}`)
				if (activeStateEl) activeStateEl.classList.add('active')
			})
		}

		function changeMobileMenuBackTriggerTitle(title: string) {
			document.querySelectorAll('.js-mobile-menu-trigger-back-title').forEach((titleEl) => {
				titleEl.innerHTML = title
			})
		}

		function handleOpen() {
			changeMobileMenuTriggerState('close')
			toggleMobileMenu()
		}

		function handleClose() {
			changeMobileMenuTriggerState('open')
			toggleMobileMenu()
		}

		function handleGo(el: HTMLElement) {
			const subMenuEl = el.querySelector('.sub-menu')
			const menuItemTitleEl = el.querySelector('.menu-item-label')
			if (!subMenuEl || !menuItemTitleEl) return

			changeMobileMenuBackTriggerTitle(menuItemTitleEl.innerText)
			changeMobileMenuTriggerState('back')
			subMenuEl.classList.add('active')
		}

		function handleBack() {
			const activeMobileSubmenuEl = document.querySelector('.mobile-menu .sub-menu.active')
			if (!activeMobileSubmenuEl) return

			changeMobileMenuTriggerState('close')
			activeMobileSubmenuEl.classList.remove('active')
		}
	}

	function initTopbarSwiper() {
		const MOBILE_WIDTH = 520
		let swiperInstance = null

		function transformTopbar() {
			const headerTop = document.querySelector('.header-top > .header-top-section:first-child')
			const isMobile = window.innerWidth < MOBILE_WIDTH

			if (isMobile && !swiperInstance) {
				const wrapper = document.createElement('div')
				wrapper.className = 'swiper topbar-swiper-mobile'
				const swiperWrapper = document.createElement('div')
				swiperWrapper.className = 'header-top-section swiper-wrapper'

				Array.from(headerTop.children).forEach((child) => {
					const slide = document.createElement('div')
					slide.className = 'swiper-slide'
					slide.appendChild(child.cloneNode(true))
					swiperWrapper.appendChild(slide)
				})

				wrapper.appendChild(swiperWrapper)
				headerTop.style.display = 'none'
				headerTop.after(wrapper)

				swiperInstance = new Swiper('.topbar-swiper-mobile', {
					slidesPerView: 1,
					loop: true,
					autoplay: { delay: 0 },
					speed: 10000,
					modules: [Autoplay],
				})
			} else if (!isMobile && swiperInstance) {
				swiperInstance.destroy(true, true)
				swiperInstance = null
				const swiperEl = document.querySelector('.topbar-swiper-mobile')
				if (swiperEl) swiperEl.remove()
				headerTop.style.display = ''
			}
		}

		let resizeTimeout
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimeout)
			resizeTimeout = setTimeout(transformTopbar, 150)
		})

		transformTopbar()
	}

	function initDesktopDropdownMenu() {
		const menuItems = document.querySelectorAll('#header-menu .menu-item-has-children > a')
		const isTouchDevice = navigator.maxTouchPoints > 0 || 'ontouchstart' in window

		if (!isTouchDevice) return

		menuItems.forEach((item) => {
			item.addEventListener('click', (e) => {
				const parent = item.parentElement
				if (window.innerWidth < 1191) return

				if (!parent.classList.contains('dropdown-open')) {
					e.preventDefault()
					closeAllDropdowns()
					parent.classList.add('dropdown-open')
				}
			})
		})

		document.addEventListener('click', (e) => {
			if (!e.target.closest('#header-menu')) {
				closeAllDropdowns()
			}
		})

		function closeAllDropdowns() {
			document.querySelectorAll('.dropdown-open').forEach((openItem) => {
				openItem.classList.remove('dropdown-open')
			})
		}
	}

	async function injectTemplates(templates) {
		let allSucceeded = true;

		for (const {
			selector,
			ajaxAction
		} of templates) {
			const containerEl = document.querySelector <HTMLElement> (selector);

			if (!containerEl || containerEl.dataset.mounted === 'true') {
				continue;
			}

			const cacheKey = `menu_cache_${ajaxAction}`;

			try {
				const cachedHtml = sessionStorage.getItem(cacheKey);

				if (cachedHtml) {
					containerEl.innerHTML = cachedHtml;
					containerEl.dataset.mounted = 'true';
					continue;
				}

				const response = await fetch(
					`${window.themeAjax.ajaxurl}?action=${ajaxAction}&nonce=${window.themeAjax.nonce}`, {
						credentials: 'same-origin',
					}
				);

				if (!response.ok) {
					throw new Error(`Network response was not ok: ${response.statusText}`);
				}

				const data = await response.json();

				if (data.success) {
					const menuHtml = data.data;
					containerEl.innerHTML = menuHtml;
					containerEl.dataset.mounted = 'true';

					try {
						sessionStorage.setItem(cacheKey, menuHtml);
					} catch (e) {
						console.warn(`Could not save template to sessionStorage for ${selector}:`, e);
					}

				} else {
					console.error(`Failed to load AJAX template for ${selector}:`, data);
					allSucceeded = false;
				}
			} catch (error) {
				console.error(`Failed to load AJAX template for ${selector}:`, error);
				allSucceeded = false;
			}
		}

		return allSucceeded;
	}

	const loadMobileMenuWithFlag = async () => {
		if (mobileMenuLoaded) {
			return;
		}
		mobileMenuLoaded = true;

		const templatesToLoad = [{
			selector: '[data-mobile-menu-content]',
			ajaxAction: 'get_mobile_menu',
		}, ];
		const loaded = await injectTemplates(templatesToLoad);
		if(loaded) {
			const dataMobileMenuContent = document.querySelector('[data-mobile-menu-content]')
			if (dataMobileMenuContent) {
				const spinner = dataMobileMenuContent.querySelector('.spinner')
				spinner?.remove();
			}
		}
	};

	let mobileMenuLoaded = false;
	document.addEventListener('DOMContentLoaded', initHeaderScripts)
	document.addEventListener(
		'scroll',
		async () => {
			const templatesToLoad = [{
				selector: '[data-header-sticky-menu-content]',
				ajaxAction: 'get_sticky_menu',
			}, ];
			await injectTemplates(templatesToLoad);
		}, {
			passive: true,
			once: true
		},
	);
	document.addEventListener('mousemove', loadMobileMenuWithFlag, {
		passive: true,
		once: true
	});
	document.addEventListener('touchstart', loadMobileMenuWithFlag, {
		passive: true,
		once: true
	});

}
